import { autoWebViewJs } from "@droid/android";
import { Log } from "@fanfanlo";

const fileLog = new Log(false, 'stopAllHandler_f');

export function stopAllHandler() {

    try {
      fileLog.log('开始停止所有紧急音频和震动...');

      // 使用正确的停止方法（与EmergencyAudioControl.tsx保持一致）
      const stopEmergencyMethods = [
        // 停止监控
        // `com.fanfanlo.emergencycall.manager.SensorManager.stopMonitoring();`,
        `
        try {
          com.fanfanlo.emergencycall.manager.SoundManager.stop();
          com.fanfanlo.emergencycall.manager.AlarmSoundManager.stop();
          com.fanfanlo.emergencycall.v2.core.EmergencySystemV2.forceStopHelpSound();
        } catch(e) {
          // console.log('停止呼救者声音失败:', e);
        }
        `,
        
        // 停止联系人报警声音（主要方法）
        `
        try {
          com.fanfanlo.emergencycall.manager.SoundManager.stopEmergencyAlarm();
          
          // 备用方案：如果WebViewActivity的Android接口可用，也调用它
          if(typeof Android !== 'undefined' && typeof Android.stopAlarm === 'function') {
            Android.stopAlarm();
          }
        } catch(e) {
          console.log('停止联系人报警声音失败:', e);
        }
        `
      ];

      for (const script of stopEmergencyMethods) {
        try {
          fileLog.log(`调用停止脚本: ${script.trim()}`);
          autoWebViewJs.callScript(script);
        } catch (methodError) {
          fileLog.warn(`停止方法调用失败:`, methodError);
          // 继续尝试其他方法
        }
      }

      fileLog.log('已停止所有紧急音频和震动');
      return true;
    //   setMessage({
    //     type: 'success',
    //     text: '已停止所有紧急音频和震动'
    //   });
    } catch (error) {
      fileLog.error('停止紧急音频失败:', error);
    //   setMessage({
    //     type: 'error',
    //     text: `停止失败: ${error instanceof Error ? error.message : '未知错误'}`
    //   });
    return false;
    } finally {
    //   setLoading(false);
    }
    
}